<template>
  <header
    id="header-wrapper"
    class="mb-3"
    :class="{
      'md-and-up position-sticky top-0 z-10': $vuetify.display.mdAndUp
    }"
  >
    <CmsBlock identifier="fe_app_maintenance" disable-animation hide-on-error />
    <CmsBlock identifier="before_header_v2" disable-animation hide-on-error />

    <div
      :style="{
        background: `rgb(var(--v-theme-white))`
      }"
      class="content d-flex flex-column"
    >
      <!-- Desktop and mobile parts are all rendered and CSS picks them
           (d-*, order-*), never v-if on $vuetify.display: a server render
           only guesses the width (1440px desktop, 820px tablet, 390px
           phone), and every part hydration had to add or remove for the real
           window shifted the page below it (VIP-12562). One SearchForm moves
           between the rows by order-* instead of two instances. -->
      <VContainer class="c-gray f-gray py-0 py-md-3 px-3 flex-grow-1">
        <div id="main-header" class="v-row justify-space-between align-center">
          <div
            class="d-none d-md-flex v-col-5 v-col-md-3"
            itemscope
            itemtype="https://schema.org/Brand"
          >
            <a href="/" class="d-flex w-100" @click.prevent="goToHome">
              <VImg
                :src="logoSrc"
                :aspect-ratio="logoAspectRatio"
                alt="vicampo-logo"
              />
            </a>
          </div>
          <SearchForm class="order-last order-md-0 px-5 px-md-0" />
          <CustomerNavigation
            class="v-col-12 v-col-md-4 v-col-lg-3 order-first order-md-0"
          />
          <MobileNavigation class="flex-grow-0 pt-5" />
        </div>
      </VContainer>

      <HeaderNavigation />
    </div>
  </header>
</template>

<script>
import logoMain from '@/assets/images/logo-main.svg'
import { LOGO_MAIN_ASPECT_RATIO } from '@/constants/GlobalConstants.js'
import { defineAsyncComponent } from 'vue'
import { VImg } from 'vuetify/components'

const CustomerNavigation = defineAsyncComponent(
  () => import('@/components/basic/molecules/CustomerNavigation.vue')
)
const CmsBlock = defineAsyncComponent(
  () => import('@/components/basic/atoms/CmsBlock.vue')
)
const SearchForm = defineAsyncComponent(
  () => import('@/components/basic/atoms/TheSearchForm.vue')
)
const HeaderNavigation = defineAsyncComponent(
  () => import('@/components/basic/molecules/HeaderNavigation.vue')
)
const MobileNavigation = defineAsyncComponent(
  () => import('@/components/basic/atoms/MobileNavigation.vue')
)

export default {
  components: {
    CustomerNavigation,
    CmsBlock,
    SearchForm,
    HeaderNavigation,
    VImg,
    MobileNavigation
  },
  computed: {
    logoSrc() {
      return logoMain
    },
    logoAspectRatio() {
      return LOGO_MAIN_ASPECT_RATIO
    }
  },
  methods: {
    goToHome() {
      this.$route.path !== '/' ? this.$router.push('/') : this.$router.go('/')
    }
  }
}
</script>

<style scoped>
.content {
  min-height: 150px;
}

.md-and-up .content {
  min-height: 150px;
}

#main-header > div,
#main-header > form {
  display: flex;
  align-items: center;
  height: 75px;
}
</style>
